import $ from "jquery";

export type QuickAlertType = 'success' | 'error' | 'info';

export function quickAlert(message: string, type: QuickAlertType = 'success'): void {
    if (!message) return;

    let $container = $('.quick-alert-area');

    if (!$container.length) {
        $container = $('<div class="quick-alert-area"></div>').appendTo('body');
    }

    const className = 'quick-alert-' + type;

    let alertTitle = 'Success';
    if (type === 'error') alertTitle = 'Error';
    else if (type === 'info') alertTitle = 'Info';

    const $alert = $(`
        <div role="alert" class="alert">
            <div class="d-flex">
                <i class="quick-alert-icon ${className}"></i>
                <div class="quick-alert-text">
                    <h2 class="quick-alert-title">${alertTitle}</h2>
                    <p class="quick-alert-message">${message}</p>
                    <div class="close">&times;</div>
                </div>
            </div>
        </div>
    `);

    $alert
        .appendTo($container)
        .fadeIn()
        .css('transform', 'translate3d(0%, 0px, 0px)');

    if (type === 'success') {
        setTimeout(() => removeAlert($alert), 5000);
    }

    $alert.find('.close').on('click', (e) => {
        e.preventDefault();
        removeAlert($alert);
    });
}

function removeAlert($alert: JQuery<HTMLElement>): void {
    const isRtl = $('html').attr('dir') === 'rtl';

    $alert
        .css('transform', isRtl ? 'translate3d(-100%, 0px, 0px)' : 'translate3d(100%, 0px, 0px)')
        .fadeOut(200, function () {
            $alert.remove();
        });
}